import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { SkeletonSquare } from '@fiverr-private/feedback';
import { ProductGroup } from './types';

interface PackageCardIconsProps {
    productGroups: ProductGroup[];
}

export const PackageCardIcons = ({ productGroups }: PackageCardIconsProps) => (
    <Stack gap="6" direction="column">
        {productGroups.map(({ title, products: icons }) => (
            <Stack direction="column" gap="4" key={title}>
                <Typography size="b_sm" fontWeight="bold">
                    {title}
                </Typography>
                <Stack justifyContent="flexStart" wrap="wrap" gap="4">
                    {icons.map(({ name: iconName, icon: IconComponent }) => (
                        <Stack direction="column" alignItems="flexStart" gap="1" key={iconName} width="56px">
                            <IconComponent size={32} fallback={<SkeletonSquare width="32px" height="32px" />} />
                            <Typography size="b_xxs" lineHeight="b_xs">
                                {iconName}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            </Stack>
        ))}
    </Stack>
);
